import styled from "styled-components";

const MenuItem = styled.p`
  color: #fff;
  font-weight: bold;
  padding: 5% 0;
  margin: 0;
  text-align: center;
  :hover {
    color: #fbb700;
  }
`;

export default MenuItem;
